import type { ChildrenProps } from "../types";

export function ModalWrapper({ children }: ChildrenProps) {
	return children;
	/** Render */
	// return <AnimatePresence mode="wait">{children}</AnimatePresence>;
}
